<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-8"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Contrato:</span>
                    <span class="font-semibold font-italic">{{ form.etapa_descricao || form.etapa }}</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">
            <Tabs class="contrato-tab-principal" v-model:value="tabIndex" @update:value="onUpdateValue">
                <TabList>
                    <Tab :value="ETAPA.LEAD">
                        <Tag v-if="form.etapa == ETAPA.LEAD" severity="info" value="Lead"></Tag>
                        <template v-else>
                            Lead
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="ETAPA.COTACAO">
                        <Tag v-if="form.etapa == ETAPA.COTACAO || form.etapa == ETAPA.AGUARDANDO" severity="info" value="Cotação"></Tag>
                        <template v-else>
                            Cotação
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="ETAPA.PROVEDOR">
                        <Tag v-if="form.etapa == ETAPA.PROVEDOR" severity="info" value="Provedor"></Tag>
                        <template v-else>
                            Provedor
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="ETAPA.ASSINATURA">
                        <Tag v-if="form.etapa == ETAPA.ASSINATURA" severity="info" value="Assinatura"></Tag>
                        <template v-else>
                            Assinatura
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="ETAPA.AGENDAMENTO">
                        <Tag v-if="form.etapa == ETAPA.AGENDAMENTO" severity="info" value="Agendamento"></Tag>
                        <template v-else>
                            Agendamento
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="ETAPA.INSTALACAO">
                        <Tag v-if="form.etapa == ETAPA.INSTALACAO" severity="info" value="Instalação"></Tag>
                        <template v-else>
                            Instalação
                        </template>
                    </Tab>
                    <Tab :disabled="!form.id" :value="TAB_PENDENCIAS">
                        Pendências <Badge v-if="form.id && pendencias" :value="pendencias" severity="warn"></Badge>
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="ETAPA.LEAD">
                        <ScrollPanel style="height: 65vh">
                            <FormTabLead :form="form" :errors="errors" :permissoes="permissoes" @consultaCep="consultaCep" @selectCliente="selectCliente" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="ETAPA.COTACAO">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabCotacao :contrato="form" :permissoes="permissoes" @aprovacao="loadForm" @save="$emit('save')" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="ETAPA.PROVEDOR">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabPreenchimento :contrato="form" :permissoes="permissoes" @save="onSavePreenchimento" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="ETAPA.ASSINATURA">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabAssinatura :contrato="form" :permissoes="permissoes" @save="onSaveAssinatura" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="ETAPA.AGENDAMENTO">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabAgendamento :form="form" :permissoes="permissoes" @save="$emit('save')" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="ETAPA.INSTALACAO">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabInstalacao :contrato="form" :permissoes="permissoes" @save="$emit('save')" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="TAB_PENDENCIAS">
                        <ScrollPanel v-if="form.id" style="height: 65vh">
                            <FormTabPendencia :contrato="form" :permissoes="permissoes" @save="$emit('save')" @updateQtd= "updateQtd" />
                        </ScrollPanel>
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-start flex-wrap gap-1">
                    <div class="text-xs">
                        <span class="text-red-500">*</span> obrigatório<br>
                        <span class="text-red-500">**</span> liberado por autorização
                    </div>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id &&
                              form.etapa != ETAPA.CONCLUIDO &&
                              form.etapa != ETAPA.CANCELADO"
                        label="Próxima Etapa"
                        severity="info"
                        icon="pi pi-arrow-right"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="onBtProximo"
                        :loading="isLoading" />
                    <Button
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        <AuthorizationForm :visible="visibleAuthForm" :errors="errors" :message="msg" @close="this.visibleAuthForm=false" @submit="onSubmitAuth" ></AuthorizationForm>
        <ConfirmacaoForm :visible="visibleConfirmacaoForm" :errors="errors" :permissoes="permissoes" @close="this.visibleConfirmacaoForm=false" @submit="onSubmitConfirmacao" ></ConfirmacaoForm>
        <LogForm :visible="visibleLogForm" table="contratos" :tableId="form.id" @close="this.visibleLogForm=false" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ScrollPanel from 'primevue/scrollpanel';
import Badge from 'primevue/badge';
import Tag from 'primevue/tag';

import Contrato from '@/service/contrato.js';

import FormTabLead from '@/page/contrato/FormTabLead.vue';
import FormTabCotacao from '@/page/contrato/FormTabCotacao.vue';
import FormTabPreenchimento from '@/page/contrato/FormTabPreenchimento.vue';
import FormTabAssinatura from '@/page/contrato/FormTabAssinatura.vue';
import FormTabInstalacao from '@/page/contrato/FormTabInstalacao.vue';
import FormTabAgendamento from '@/page/contrato/FormTabAgendamento.vue';
import FormTabPendencia from '@/page/contrato/FormTabPendencia.vue';

import ConfirmacaoForm from '@/page/contrato/ConfirmacaoForm.vue';

import AuthorizationForm from '@/components/auth/AuthorizationForm.vue';
import LogForm from '@/components/LogForm.vue';

export default {
    components: { Dialog,
                  Button,
                  Tabs,
                  TabList,
                  Tab,
                  TabPanels,
                  TabPanel,
                  ScrollPanel,
                  Badge,
                  Tag,
                  LogForm,

                  /* Forms */
                  AuthorizationForm,
                  ConfirmacaoForm,
                  LogForm,

                  /* Tabs */
                  FormTabLead,
                  FormTabCotacao,
                  FormTabPreenchimento,
                  FormTabAssinatura,
                  FormTabInstalacao,
                  FormTabPendencia,
                  FormTabAgendamento,
                },
    props: {
        id: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        etapa: {
            type: [String, Number],
            default: 0
        },
        permissoes: {},
    },
    emits: ['save','close'],
    data() {
        return {
            form: {},
            errors: {},
            msg: null,
            isLoading: false,
            pendencias: 0,

            formComfirmacao: {},
            visibleConfirmacaoForm: false,
            visibleAuthForm: false,
            visibleLogForm: false,
            tabIndex: constantes.ETAPA.LEAD,
            TAB_PENDENCIAS: 'pendencias',

            ETAPA: constantes.ETAPA,
            submitBy: 'form',
        }
    },
    methods: {
        onUpdateValue(tabIndex) {
            const event = new Event("onContratoTabChange");
            event.tabIndex = tabIndex;
            document.dispatchEvent(event);
        },
        updateQtd(qtd){
            this.pendencias  = qtd;
        },
        onShow() {
            if(this.id) {
                return this.loadContrato();
            }
            this.form = Contrato.parse({...this.data});
            this.setTabIndex(this.etapa);
        },
        onHide() {
            this.tabIndex = this.ETAPA.LEAD;
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        loadForm(form) {
            this.form = Contrato.parse(form);
            this.setTabIndex(this.etapa);
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if(form.id) {
                return Contrato.update(form.id,form);
            }
            return Contrato.create(form);
        },
        onSavePreenchimento(data) {
            if(data) {
                this.form.preenchimento_id      = data.id;
                this.form.preenchimento         = data.nome;
                this.form.preenchimento_download= data.caminho_arquivo;
                this.form.preenchimento_date    = data.created_at?new Date(data.created_at):null;
                this.form.preenchimento_usuario = data.usuario?data.usuario.nome:null;
            }
            this.$emit('save');
        },
        onSaveAssinatura(data) {
            if(data) {
                this.form.assinatura_id      = data.id;
                this.form.assinatura         = data.nome;
                this.form.assinatura_date    = data.created_at?new Date(data.created_at):null;
                this.form.assinatura_usuario = data.usuario?data.usuario.nome:null;
            }
            this.$emit('save');
        },
        setTabIndex(tabEtapa) {
            if(!tabEtapa) {
                let tabIndex = this.ETAPA.LEAD;
                if([this.ETAPA.CANCELADO, this.ETAPA.CONCLUIDO, this.ETAPA.LEAD].indexOf(this.form.etapa) < 0) {
                    tabIndex = this.form.etapa;
                }
                if([this.ETAPA.AGUARDANDO].indexOf(this.form.etapa) >= 0) {
                    tabIndex = this.ETAPA.COTACAO;
                }
                if(!tabIndex) {
                    tabIndex = this.ETAPA.LEAD;
                }
                this.tabIndex = tabIndex;
            } else {
                this.tabIndex = tabEtapa;
            }
        },
        loadContrato() {
            this.isLoading = true;
            Contrato.get(this.id)
                .then(response => {
                    this.loadForm(response.data);
                })
                .finally(() => this.isLoading = false);
        },
        consultaCep(dados) {
            this.form.endereco1 = dados.endereco1;
            this.form.endereco2 = dados.endereco2;
            this.form.cidade_id = dados.cidade_id;
            this.form.estado_id = dados.estado_id;
        },
        selectCliente(cliente) {
            this.form.cliente       = null;
            this.form.cliente_id    = null;

            if(cliente) {
                this.form.cliente       = cliente.nome;
                this.form.cliente_id    = cliente.id;
                if(cliente.valor_referencia) {
                    this.form.valor_referencia = cliente.valor_referencia;
                }
                if(cliente.duracao) {
                    this.form.duracao       = cliente.duracao;
                }
            }
        },
        onSubmitAuth(formAuth) {
            if(this.submitBy == 'form') {
                const contrato = {...this.form};
                contrato.autorization = formAuth;

                this.sendSubmit(contrato);
            } else {
                const contrato = {...this.formComfirmacao};
                contrato.autorization = formAuth;

                this.proximo(contrato);
            }
        },
        onSubmitConfirmacao(form) {
            this.formComfirmacao = form;
            this.proximo(form);
        },
        onSubmit(form) {
            this.msg    = null;
            this.errors = {};

            this.submitBy = 'form';
            this.sendSubmit(form);
        },
        sendSubmit(form) {
            this.errors = {};
            this.isLoading = true;

            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });

                    this.form = Contrato.parse(response.data.data);
                    this.visibleAuthForm = false;

                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        this.visibleAuthForm = (err.auth == true);
                        if(err.msg) {
                            this.msg = err.msg;
                        }
                        
                        if(err.erros && Object.getPrototypeOf(err.erros)) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.visibleAuthForm = false;
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onBtProximo() {
            this.$confirm.require({
                message: 'Deseja mover o contrato para a próxima etapa?',
                header: 'Próxima Etapa',
                acceptLabel: 'Próximo',
                icon: 'pi pi-arrow-right',
                acceptClass: 'bg-success-500 text-white',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-500 text-white border-red-500',
                accept: () => {
                    this.proximo();
                },
            });
        },
        proximo(contrato = null) {
            this.msg    = null;
            this.errors = {};
            this.isLoading = true;

            this.submitBy = 'proximo';
            Contrato.proximo(this.form.id, contrato)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });

                    this.form = Contrato.parse(response.data.data);

                    this.visibleConfirmacaoForm = false;
                    this.visibleAuthForm = false;
                    this.formComfirmacao = {};
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;

                        if(err.msg) {
                            this.msg = err.msg;
                        }
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                        }

                        this.visibleAuthForm = false;
                        this.visibleConfirmacaoForm = false;

                        if(err.form) {
                            this.visibleConfirmacaoForm = true;
                            return;
                        }

                        this.visibleAuthForm = false;
                        if(err.auth) {
                            this.visibleAuthForm = true;
                            return;
                        }

                        if(err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.visibleAuthForm = false;
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>

<style>
    .contrato-tab-principal .p-tabpanels {
        padding: 0;
    }
    .contrato-tab-principal .p-scrollpanel {
        padding: var(--p-tabs-tabpanel-padding);
    }
</style>
